/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuperGroupResponse
 */
export interface SuperGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof SuperGroupResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SuperGroupResponse
     */
    name: string | null;
}

export function SuperGroupResponseFromJSON(json: any): SuperGroupResponse {
    return SuperGroupResponseFromJSONTyped(json, false);
}

export function SuperGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuperGroupResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function SuperGroupResponseToJSON(value?: SuperGroupResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

